export class BuildKey {
    constructor(buildNumber, buildOs, buildArchitecture, buildRemoteEnvironment) {
        this.buildNumber = buildNumber;
        this.buildOs = buildOs;
        this.buildArchitecture = buildArchitecture;
        this.buildRemoteEnvironment = buildRemoteEnvironment;
    }
    static fromProductBuild(build) {
        return new BuildKey(build.buildNumber, build.buildOs, build.buildArchitecture, build.buildEnv);
    }
    static getValidBuildKey(build) {
        return `${build.buildNumber}:${build.buildOs}:${build.buildArchitecture}:${build.buildEnv}`;
    }
    getValidBuildKey() {
        if (this.buildNumber && this.buildOs && this.buildArchitecture) {
            return `${this.buildNumber}:${this.buildOs}:${this.buildArchitecture}:${this.buildRemoteEnvironment}`;
        }
        return undefined;
    }
}
